import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api';

interface NotificationCounts {
    unreadMessages: number;
    pendingTasks: number;
}

export const useNotificationCounts = () => {
    // Fetch unread message count
    const { data: messagesData } = useQuery({
        queryKey: ['notifications', 'unreadMessages'],
        queryFn: async () => {
            try {
                const response = await apiClient.get<{ success: boolean; data: { count: number } }>('/api/messages/unread-count');
                return response.data?.count || 0;
            } catch (error) {
                console.error('Failed to fetch unread messages:', error);
                return 0;
            }
        },
        refetchInterval: 30000, // Refetch every 30 seconds
        staleTime: 15000,
    });

    // Fetch unseen tasks count (tasks assigned to user that haven't been viewed yet)
    const { data: tasksData } = useQuery({
        queryKey: ['notifications', 'pendingTasks'],
        queryFn: async () => {
            try {
                const response = await apiClient.get<{ success: boolean; data: { count: number } }>('/api/tasks/unseen-count');
                return response.data?.count ?? 0;
            } catch (error) {
                console.error('Failed to fetch unseen tasks:', error);
                return 0;
            }
        },
        refetchInterval: 30000,
        staleTime: 15000,
    });

    return {
        unreadMessages: messagesData || 0,
        pendingTasks: tasksData || 0,
    };
};
